import React, { useRef, useState } from 'react';

interface MediaPlayerProps {
  src: string;
  mimeType: string;
}

export default function MediaPlayer({ src, mimeType }: MediaPlayerProps) {
  const mediaRef = useRef<HTMLVideoElement & HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);

  const isAudio = mimeType.startsWith('audio/');
  const Tag = isAudio ? 'audio' : 'video';

  const toggle = () => {
    const el = mediaRef.current;
    if (!el) return;
    if (playing) {
      el.pause();
    } else {
      el.play();
    }
  };

  return (
    <div className="iio-media-player">
      <Tag
        ref={mediaRef as any}
        src={src}
        controls
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        className="iio-media-element"
      />
    </div>
  );
}
